import { populate } from "populate";

const raw = {
  className: 'SmallBeachchairsLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "daf36083-237f-4abc-b35a-b8c76538bc28",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "dd33a16c-811f-4954-a8a5-32234bf1f80a",
      type: "Sprite",
      name: "item",
      nameSpace: "",
      className: "small_beachchairs",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.65
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "small_beachchairs",
      parent: "daf36083-237f-4abc-b35a-b8c76538bc28",
      data: ""
    }
  ]
} as const;

export class SmallBeachchairsLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  item: GameObject<PIXI.Sprite>;
  small_beachchairs: (GameObject<PIXI.Sprite>)[];

  constructor() {
    populate(this, raw);
  }
}
